<template>
  <div id="informationComfirm">
    <div class="Grid85004776">
      <div class="Grid3CFB3B2B">
        <div>
          <md-field-item
            :content="SelectorBox6ECF.content"
            :title="$t('label.label98')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :content="SelectorBox97E8.content"
            :title="$t('label.label99')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div v-if="proInfo.prodType === 'FP01060002' || proInfo.prodType === 'FP01060004' ">
          <md-field-item
            :content="rates"
            :title="$t('label.label66')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :content="SelectorBoxB14C.content"
            :title="$t('label.label100')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
<!--        <div v-if="prodType === 'FP01060006'">-->
<!--           <md-field-item-->
<!--            :content="maturity"-->
<!--            :title="'到期后安排'"-->
<!--            :solid="true"-->
<!--            :align="'right'"-->
<!--          >-->
<!--          </md-field-item>-->
<!--        </div>-->
      </div>
      <div class="Grid3BD34410">
        <span text="'存入金额（元）'" class="textF0892176">
          {{$t('label.label101')}}
        </span>
        <md-field-item
          :content="InputItem56A0.value"
          :solid="true"
        />
      </div>
      <div class="GridE89DD886">
        <div class="itemdia">
          <md-field-item
            :content="proInfo.ccy+this.$commafy(proInfo.availableBalance)"
            :title="$t('label.label105')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :content="proInfo.ccy+this.$commafy(incomeMoney)"
            :title="$t('label.label188')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
      </div>
<!--      <div class="GridCB5CCE6B">-->
<!--        <md-agree-->
<!--          :text="'我已閱讀協議條款，清楚並同意該協議條款。'"-->
<!--          v-model="Agree8723.value"-->
<!--          >{{$t('label.label106')}}-->
<!--        </md-agree>-->
<!--      </div>-->
      <div class="Grid39DAC6A9">
        <md-button :text="'确定'" :type="'primary'" :round="true" @click="getTime">{{$t('btn.btn1')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { FieldItem, Selector, InputItem, Agree, Button, Picker, Dialog } from '@gidc/mobile'
import {
  USERACCLIST,
  EBANKBALANCESELECT,
  PRODUCTPAY,
  BILLACCOUNTNO,
  PRODBUY,
  PREPURINTTRICAL,
  SMARTDEPOSITDUALAUTH,
  BUYTIMESTATE
} from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
export default {
  name: 'informationEntryOfDay',
  components: {
    [FieldItem.name]: FieldItem,
    [Selector.name]: Selector,
    [InputItem.name]: InputItem,
    [Agree.name]: Agree,
    [Picker.name]: Picker,
    [Button.name]: Button
  },
  computed: {
    ...mapGetters([
      'RnInfo',
      'proInfo',
      'headerInfo'
    ])
  },
  watch: {
    headerInfo: function (newval, oldval) {
      console.log("newval.headers['x-business-token']", newval.headers['x-business-token'])
      this.dualAuthenticationSecond(newval.headers['x-business-token'])
    }
  },
  data () {
    return {
      SelectorBox6ECF: {
        content: '',
        value: false,
        data: [[]]
      },
      SelectorBox97E8: {
        content: '',
        value: false,
        data: [[]]
      },
      SelectorBoxB14C: {
        content: '',
        value: false,
        data: [[]]
      },
      InputItem56A0: {
        value: '计划名称'
      },
      Agree8723: {
        value: false
      },
      availableBalance: '',
      payleName: '',
      accID: '',
      payCcy: '',
      maturity: '',
      payAcctNo: '', // 真是卡号
      incomeMoney: '', // 预期收益
      prodType: '', // 产品类型
      rates: ''
    }
  },
  methods: {
    getInterest () {
      const params = {
        prodType: this.proInfo.prodType, // 产品类型日日赚：FP01060005，月月高：FP01060002
        ccy: this.SelectorBox6ECF.content, // 币种
        tranAmt: this.proInfo.tranAmt, // 金额
        startDate: '', // 起存日期
        depositTerm: this.proInfo.depositTermValue, // 存期
        agreementAmt: this.proInfo.payMoney, // 供款金额FP01060001零存整取智能存款上送
        floatValue: '', // 浮动值
        targetAmt: ''
      }
      this.$remote.post(PREPURINTTRICAL + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.incomeMoney = res.intTotal
          if (this.proInfo.prodClass === 'FP103' || this.proInfo.prodClass === 'FP102') {
            const t = res.updateIntRate.split(',')
            this.rates = res.intRate + '%+' + t[1] + '%+' + t[2] + '%'
          }
        })
    },
    dualAuthentication () {
      const params = {
        _token_name: this.RnInfo.token
      }
      this.$remote.post(SMARTDEPOSITDUALAUTH + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.bodyMap.code === '418') {
            window.emitRNFunction('authentication', res.bodyMap.data.strategys[0])
          }
        })
    },
    dualAuthenticationSecond (token) {
      const params = {
        _token_name: this.RnInfo.token
      }
      this.$remote.post(SMARTDEPOSITDUALAUTH + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, xBusinessToken: token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.status === '200') {
            this.buyPro()
          }
        })
    },
    buyPro () {
      if (this.prodType === 'FP01060002') {
        const params = {
          prodType: this.prodType, // 产品类型
          accountId: this.proInfo.accID,
          depositTerm: this.proInfo.depositTermValue, // 存期
          ccy: this.SelectorBox6ECF.content, // 币种
          buyBaseAcctNo: this.payAcctNo, // 购买账号
          tranAmt: this.InputItem56A0.value // 购买金额
        }
        this.$remote.post(PRODBUY + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
          .then(res => {
            this.$router.push({ name: 'transactionResult', params: { tranAmt: this.InputItem56A0.value, baseAcctNo: res.baseAcctNo, status: true } })
          })
          .catch(err => {
            this.$router.push({ name: 'transactionResult', params: { msg: err.msg, status: false } })
          })
      } else {
        const params = {
          serviceCode: 'MBSD_BP_BS',
          messageType: '1000',
          messageCode: '0016',
          prodType: this.prodType, // 产品类型
          userAccountId: this.proInfo.accID,
          depositTerm: this.proInfo.depositTermValue, // 存期
          ccy: this.SelectorBox6ECF.content, // 币种
          buyBaseAcctNo: this.payAcctNo, // 购买账号
          withdrawBaseAcctNo: this.payAcctNo,
          tranAmt: this.InputItem56A0.value // 购买金额
        }
        if (this.prodType === 'FP01060006') {
          params.autoFlag = this.proInfo.autoFlag
        }
        this.$remote.post(PRODUCTPAY + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
          .then(res => {
            this.$router.push({ name: 'transactionResult', params: { tranAmt: this.InputItem56A0.value, status: true, baseAcctNo: res.baseAcctNo } })
          })
          .catch(err => {
            this.$router.push({ name: 'transactionResult', params: { msg: err.msg, status: false } })
          })
      }
    },
    getAccNo () {
      const resParams = {
        id: this.accID
      }
      this.$remote.post(BILLACCOUNTNO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), resParams, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.payAcctNo = res.accountNo
          this.getBillExcharge(this.payCcy, res.accountNo)
        })
    },
    showBalanceClick () {
      const params = {
        accountNo: this.accID,
        paymentCurrency: this.payCcy,
        reccivingCurrency: 'CNY'
      }
      this.$remote.post(EBANKBALANCESELECT + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.availableBalance = res.availableBalance
        })
    },
    getAccNoList () {
      const params = {}
      this.$remote.post(USERACCLIST + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          res.list.forEach(item => {
            item = { text: item.currency + '-' + item.accountCoreNo, value: item.id, currency: item.currency }
            this.SelectorBoxB14C.data[0].push(item)
          })
          this.SelectorBoxB14C.content = this.SelectorBoxB14C.data[0][0].text
          this.payCcy = this.SelectorBoxB14C.data[0][0].currency
          this.accID = this.SelectorBoxB14C.data[0][0].value
          this.showBalanceClick()
        })
    },
    chooseSelectorBox6ECF (obj) {
      this.SelectorBox6ECF.content = obj[0].text
    },
    chooseSelectorBox97E8 (obj) {
      this.SelectorBox97E8.content = obj[0].text
      if (this.proInfo.prodType === 'FP01060002') {
        if (this.proInfo.depositTermValue === 'M6') {
          this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('6', '3+2+1')
        } else if (this.proInfo.depositTermValue === 'M12') {
          this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('12', '5+5+2')
        }
      } else if (this.proInfo.prodType === 'FP01060004') {
        if (this.proInfo.depositTermValue === 'D50') {
          this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('50', '30+15+5')
        } else if (this.proInfo.depositTermValue === 'D100') {
          this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('100', '60+30+10')
        } else if (this.proInfo.depositTermValue === 'D160') {
          this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('160', '100+50+10')
        }
      }
    },
    chooseSelectorBoxB14C (obj) {
      this.SelectorBoxB14C.content = obj[0].text
    },
    getTime () {
      this.$remote.post(BUYTIMESTATE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), {}, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.buyTimeState === 'true') {
            this.dualAuthentication()
          } else {
            Dialog.alert({
              content: this.$t('label.label3'),
              cancelText: this.$t('btn.btn2'),
              confirmText: this.$t('btn.btn1'),
              onConfirm: () => window.emitRNFunction('goToPage')
            })
          }
        })
    }
  },
  mounted () {
    console.log('this i s proInfo', this.proInfo)
    this.SelectorBox97E8.content = this.proInfo.depositTerm // 存期
    if (this.proInfo.prodType === 'FP01060002') {
      if (this.proInfo.depositTermValue === 'M6') {
        this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('6', '3+2+1')
        this.rates = this.proInfo.rates
      } else if (this.proInfo.depositTermValue === 'M12') {
        this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('12', '5+5+2')
        this.rates = this.proInfo.rates
      }
    } else if (this.proInfo.prodType === 'FP01060004') {
      if (this.proInfo.depositTermValue === 'D50') {
        this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('50', '30+15+5')
      } else if (this.proInfo.depositTermValue === 'D100') {
        this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('100', '60+30+10')
      } else if (this.proInfo.depositTermValue === 'D160') {
        this.SelectorBox97E8.content = this.SelectorBox97E8.content.replace('160', '100+50+10')
      }
    }
    this.SelectorBox6ECF.content = this.proInfo.ccy // 币种
    this.SelectorBoxB14C.content = this.proInfo.buyBaseAcctNo // 购买账号
    this.InputItem56A0.value = this.proInfo.tranAmt // 购买金额
    this.payleName = this.proInfo.tranAmt // 购买金额
    this.Agree8723.value = this.proInfo.Agree8723
    this.payAcctNo = this.proInfo.payAcctNo
    this.prodType = this.proInfo.prodType
    this.maturity = this.proInfo.maturity
    this.getInterest()
  },
  created () {
  }
}
</script>
<style lang="stylus">
  #informationComfirm{
    .Grid85004776{
      .Grid3CFB3B2B,.GridE89DD886{
        .md-field-item{
          .md-field-item-content{
            min-height .92rem
            height .92rem
            .md-field-item-title{
              font-size .28rem
              font-weight 400
              color #1E1E1E
              line-height .4rem
              text-align left
            }
            .md-field-item-control{
              height .4rem
              font-size .28rem
              font-weight 400
              color #333333
              line-height .4rem
              input{
                height 40px
                font-size 28px
                font-weight 400
                color #333333
                line-height 40px
                text-align right
              }
              input::placeholder {
                      color #999999
                      font-weight 400
                      font-size .28rem
                      height .4rem
                      line-height .4rem
                    }
              .md-field-item-placeholder{
                height .4rem
                font-size .28rem
                font-weight 400
                color #999999
                line-height .4rem
              }
            }
          }
        }
        .itemdia{
          .md-field-item-content{
            .md-field-item-title{
              width 60vw
              word-wrap break-word
              overflow: hidden;
            }
          }
        }
      }
      .Grid3BD34410{
        .md-field-item{
          padding .3rem 0
          .md-field-item-content{
            height .4rem
            min-height .4rem
            .md-field-item-control{
              padding 0 .3rem
              font-weight 400
              color #333333
              font-size .28rem
              height .4rem
              line-height .4rem
            }
          }
          .md-field-item-content::before{
            content none
          }
        }
      }
      .Grid39DAC6A9{
        .md-button{
          height .92rem
          min-height .9rem
          .md-button-inner{
            .md-button-content{
              height .5rem
              font-size .36rem
              font-weight 500
              color #FFFFFF
              line-height .5rem
            }
          }
        }
        .md-button.primary{
          background linear-gradient(135deg, #4792F7 0%, #2B80F4 100%)
          border-radius .46rem
        }
      }
    }
  }
</style>
<style lang="stylus" scoped>
  #informationComfirm{
    .Grid85004776{
      .Grid3CFB3B2B,.GridE89DD886{
        padding 0 .3rem
      }
      .Grid3BD34410{
        position relative
        padding .3rem .3rem 0
        .textF0892176{
          font-size .28rem
          display block
          font-weight 400
          height .4rem
          line-height .4rem
          color #1E1E1E
        }
      }
      .Grid3BD34410::after{
        position absolute
        bottom 0
        content ''
        width 92%
        height .02rem
        background #ECECEC
      }
      .GridCB5CCE6B{
        font-size .2rem
        font-weight 400
        color #999999
        line-height .28rem
        padding .3rem
      }
      .Grid39DAC6A9{
        padding .6rem .3rem .3rem
      }
    }
  }
</style>
